<template>
  <div class="gadget topic-card-container">
    最新话题
    <div v-for="(topic, index) in topics" class="home-topic-card" :key="index">
      <div>
        <div class="topic-content">
          <div class="topic-title pointer">
            <span @click="goToTopic(topic)">
              {{ topic.title }}
            </span>
            <el-link
              class="float-right"
              :href="link + 'categories/' + topic.category_id"
              target="_blank"
            >
              {{ topic.category.name }}
            </el-link>
            <price-label :price="topic.price"></price-label>
          </div>

          <div @click="goToTopic(topic)" class="topic-excerpt pointer">
            {{ topic.excerpt }}
          </div>
<!--          <div @click="goToTopic(topic)" class="topic-footer pointer">-->
<!--            <span>-->
<!--              <font-awesome-icon icon="clock" />-->
<!--              {{ topic.created_at | moment("from") }}-->
<!--            </span>-->
<!--          </div>-->
        </div>
      </div>
    </div>

    <div v-if="fetching" class="text-center">
      <div class="loading-content">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PriceLabel from "@/components/PriceLabel";

export default {
  data: function() {
    return {
      fetching: false,
      currentPage: 1,
      totalPage: 2,
      loadMoreMessage: "",
      loadedLatestpage: 0
    };
  },
  props: {
    topics: {
      type: Array,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  components: {
    PriceLabel
  },
  computed: {
    ...mapState(["topicsUrl", "currentCategoryId"]),
    queryObject: function() {
      return { ...this.queryParams, ...{ page: this.currentPage } };
    }
  },
  methods: {
    goToTopic: function(topic) {
      let url =
        this.link +
        "topics/" +
        topic.id +
        (topic.slug === null ? "" : "/" + topic.slug);
      window.open(url, "_blank");
    }
  }
};
</script>
<style scoped>
.home-topic-card {
  margin: 10px 0px;
  border-bottom: 1px solid var(--color-border-default);
}
</style>
